import {Module} from 'vuex'

const getOriginalState = () => {
  return {
    rapports: []
  }
}

export const rapportStore: Module<any, any> = {
  namespaced: true,
  state: getOriginalState(),
  mutations: {
    setRapports(state, rapports) {
      state.rapports = rapports
    },
    reinitialiser(state) {
      Object.assign(state, getOriginalState())
    }
  }
}
